import React from 'react'
import { triggerConfigs } from '../../../../../../models/flowBuilderTypes';
import { ListItemIcon, Menu, MenuItem, TableCell } from '@mui/material';
import globalStyles from "../../../../../../assets/styles/global.module.scss";
import style from "../../../../../../assets/styles/componentStyles/campaignContactStyles/campaignContactStyle.module.scss";
import workflowStyles from '../../../../../../assets/styles/componentStyles/manychatStyles/workflowFormComponents/workflowForm.module.scss'
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { getValueOrDefault, miliSecondsToHMS } from '../../../../../../utils/constants';
import { getDelayObjByValue } from '../../../flowBuilderConstants';

interface MemoizedSmartDelayTableRowProps {
    data: triggerConfigs, 
    index: number, 
    anchorEl: null | SVGSVGElement, 
    currentRowIndex: string | null,
    menuItem: { label: string; icon: JSX.Element; action: (data: any) => void, isDisable: boolean, }[]; 
    handleMenuOpen: (event: React.MouseEvent<SVGSVGElement, MouseEvent>, rowIndex: string) => void;
    handleMenuClose: () => void;   
    isMenuOpen: boolean,
    getFullConditionText: (data: triggerConfigs) => string
    getStepNameByStepId: (step_id: string, defaultValue: string) => string,
} 

const MemoizedSmartDelayTableRow: React.FC<MemoizedSmartDelayTableRowProps> = React.memo((props) => {
    
    const { data, index, anchorEl, currentRowIndex, menuItem, handleMenuOpen, handleMenuClose, getFullConditionText, getStepNameByStepId} = props;

    return (
        <>
            <TableCell 
                key={index} 
                className={`${workflowStyles.smartDelayTableBodyCell} ${style.fieldCellWidth} ${globalStyles.displayFlexStyle} ${globalStyles.alignItemCenter}`} 
            >
                {getValueOrDefault(getDelayObjByValue(data?.trigger_after_time_ms)?.label)}
            </TableCell>
            <TableCell 
                key={index} 
                className={`${workflowStyles.smartDelayTableBodyCell} ${style.fieldCellWidth} ${globalStyles.displayFlexStyle} ${globalStyles.alignItemCenter}`}
            >
                {getStepNameByStepId(getValueOrDefault(data?.target_chatbot_step_id), "-")}
            </TableCell>
            <TableCell 
                key={index} 
                className={`${workflowStyles.smartDelayTableBodyCell} ${style.fieldCellWidth} ${globalStyles.displayFlexStyle} ${globalStyles.alignItemCenter}`} 
            >
                {getValueOrDefault(String(data?.flag_trigger_on_inactivity))}
            </TableCell>
            <TableCell 
                key={index} 
                className={`${workflowStyles.smartDelayTableBodyCell} ${style.fieldCellWidth} ${globalStyles.displayFlexStyle} ${globalStyles.alignItemCenter}`} 
            >
                {getFullConditionText(data)}
            </TableCell>
            <TableCell className={`${workflowStyles.smartDelayTableBodyCell} ${style.lastColumnSticky} ${style.moreVertIcon} ${style.checkBoxCellWidth} ${globalStyles.displayFlexStyle} ${globalStyles.alignItemCenter} ${globalStyles.contentEnd}`}>
                <MoreVertIcon
                    className={globalStyles.clickable}
                    onClick={(e: React.MouseEvent<SVGSVGElement, MouseEvent>) => {
                        handleMenuOpen(e, data?.chatbot_timeout_trigger_config_id);
                    }}
                />
                <Menu
                    anchorEl={anchorEl}
                    keepMounted
                    open={Boolean(anchorEl) && (data?.chatbot_timeout_trigger_config_id) === currentRowIndex}
                    onClose={handleMenuClose}
                >
                    {menuItem.map((item, index) => {
                        return (
                            <MenuItem
                                className={`${globalStyles.menuItemStyle} ${globalStyles.secondaryFontSize}`}
                                key={index}
                                onClick={(e) => {e.stopPropagation(); handleMenuClose(); item.action(data); }}
                                disabled={item?.isDisable ?? false}
                            >
                                <ListItemIcon>
                                    {item.icon}
                                </ListItemIcon>
                                <span>
                                    {item.label}
                                </span>
                            </MenuItem>
                        );
                    })}
                </Menu>
            </TableCell>
        </>
    )
}, (prev, next) => {
    return prev.data == next.data && 
            prev.isMenuOpen == next.isMenuOpen
})

export default MemoizedSmartDelayTableRow
